import Routes from './Routes';
import Home from './Home';
import '../styles/Main.css';
import Services from './Services';
import AboutUs from './AboutUs';
import Calculator from './Calculator';
import Footer from './Footer';
import { Helmet } from 'react-helmet-async';

function Main() {
    return (
        <>
            <Helmet>
                <title>RiktigtRent | Städ i Linköping - Företagsstäd, Hemstäd, Flyttstäd</title>
                <meta
                    name="description"
                    content="RiktigtRent erbjuder företagsstäd, hemstäd och flyttstäd i Linköping och Östergötland. Kvalitet, trygghet och flexibla upplägg."
                />
                <meta
                    name="summary"
                    content="Städtjänster i Linköping: företagsstäd, hemstäd, flyttstäd, kontorsstäd. Fokus på trygghet, kvalitet och flexibla upplägg."
                />
                <meta property="og:title" content="RiktigtRent - Städ i Linköping & Östergötland" />
                <meta
                    property="og:description"
                    content="Boka företagsstäd, hemstäd eller flyttstäd. Lokal städfirma i Linköping med anpassade upplägg och trygg service."
                />
            </Helmet>
            <header className="app-header">
                <Routes />
            </header>
            <main>
                <Home />
                <Services />
                <Calculator />
                <AboutUs />
                <Footer />
            </main>
        </>
    );
}

export default Main;